<template>
    <form-container>
        <step-form-heading :icon="faFileArrowDown">
            New Export

            <template v-slot:description>
                <span class="text-sm text-slate-500">Export all of your contacts as a CSV.</span>
            </template>
        </step-form-heading>

        <vx-alert v-if="!isExportAllowed" :closeable="false" shadow class="mx-auto max-w-sm">
            You don't have permission to export contacts.
        </vx-alert>
        <vx-alert v-else-if="success" shadow :closeable="false" color="success" class="mx-auto max-w-2xl">
            <template v-slot:icon>
                <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
            </template>
            <div class="flex items-center justify-between">
                <span>Export started successfully. We'll email you when it's ready.</span>
                <vx-button href="/contacts/export/new" size="sm" color="success">
                    New Export
                    <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
                </vx-button>
            </div>
        </vx-alert>

        <form-wrapper
            v-else
            :sections="[
                { id: 'included-fields', label: 'Included Fields' },
                { id: 'custom-attributes', label: 'Custom Attributes' },
            ]"
        >

            <included-fields id="included-fields"></included-fields>
            <custom-attributes id="custom-attributes" ref="customAttributesRef"></custom-attributes>
            <vx-sticky-footer>
                <vx-button href="/contacts" class="w-20" size="lg" color="muted">
                    Cancel
                </vx-button>
                <vx-button @click="submit()" data-test="submit-button" :disabled="submiting" class="grow" size="lg"
                    color="primary" :loading="submiting">
                    Start Export
                    <font-awesome-icon widthAuto :icon="faCirclePlay"></font-awesome-icon>
                </vx-button>
            </vx-sticky-footer>

        </form-wrapper>
    </form-container>
</template>

<script setup>
import { VxButton, VxStickyFooter, VxAlert } from '@voxie/frontend-components';
import { ref } from 'vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleCheck, faFileArrowDown, faCirclePlay, faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { contactsClient } from '~/services';
import { useToasted } from '~/composables/useToasted';
import IncludedFields from './components/IncludedFields.vue';
import CustomAttributes from './components/CustomAttributes.vue'
import FormContainer from '~/components/general/FormContainer.vue';
import FormWrapper from '~/components/general/FormWrapper.vue';

const isExportAllowed = Spark.isAdminOrOwner || Spark.roleOnCurrentTeam === 'manager';
const teamId = Spark.state.currentTeam.id;

const toasted = useToasted();

const submiting = ref(false);
const success = ref(false);
const customAttributesRef = ref(null);

const submit = async () => {
    if (submiting.value) {
        return;
    }

    submiting.value = true;

    try {
        const attributes = await customAttributesRef.value.submit();
        await contactsClient.contactsExport(teamId, null, {
            'custom_attribute_keys': attributes,
        });

        success.value = true;
    } catch (error) {
        console.error(error)
        toasted.global.platform_error();
    } finally {
        submiting.value = false;
    }
}
</script>
